import { motion } from "framer-motion";
import { Users, Scale, Landmark, Handshake, Gavel, Briefcase } from "lucide-react";

const GROUPS = [
  {
    icon: Users,
    label: "Eltern",
    desc: "Strukturierte Chronik für den eigenen Fall.",
  },
  {
    icon: Briefcase,
    label: "Anwälte",
    desc: "Dokumentierte Verläufe für Mandantengespräche.",
  },
  {
    icon: Landmark,
    label: "Jugendamt",
    desc: "Objektive Grundlage für Fallberatung.",
  },
  {
    icon: Handshake,
    label: "Verfahrensbeistände",
    desc: "Klare Ereigniskette für Kinderperspektive.",
  },
  {
    icon: Scale,
    label: "Mediator:innen",
    desc: "Faktenbasierte Gespräche statt Erinnerung.",
  },
  {
    icon: Gavel,
    label: "Gerichte",
    desc: "Übersichtliche PDF-Berichte für Verfahren.",
  },
];

export default function Zielgruppen() {
  return (
    <section
      id="zielgruppen"
      data-testid="zielgruppen-section"
      className="relative py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-14">
          <span className="font-mono-bp text-[11px] tracking-[0.35em] uppercase text-[#00FAF8]">
            Kapitel 07
          </span>
          <span className="flex-1 h-px bg-gradient-to-r from-[#00FAF8]/40 via-white/10 to-transparent" />
          <span className="font-mono-bp text-[11px] tracking-[0.25em] uppercase text-white/40">
            Zielgruppen
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.03em] font-medium">
              Ein Werkzeug — <br className="hidden md:block" />
              <span className="text-white/40">sechs Perspektiven.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/60 text-lg leading-relaxed">
            BeParent ist bewusst neutral. Die Datenstruktur bleibt gleich —
            unabhängig davon, wer sie liest.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {GROUPS.map((g, i) => (
            <motion.div
              key={g.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                delay: 0.06 * i,
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="bp-card p-7 md:p-8 group"
              data-testid={`zielgruppe-${g.label.toLowerCase()}`}
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#00FAF8]/8 border border-[#00FAF8]/25 group-hover:border-[#00FAF8]/60 transition-colors">
                  <g.icon className="text-[#00FAF8]" size={20} />
                </span>
                <span className="font-mono-bp text-[11px] text-white/30 group-hover:text-[#00FAF8] transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="mt-8">
                <h3 className="font-display text-white text-2xl font-medium tracking-tight">
                  {g.label}
                </h3>
                <p className="mt-2 text-white/55 text-[15px] leading-relaxed">
                  {g.desc}
                </p>
              </div>

              <div className="mt-8 pt-5 border-t border-white/5 flex items-center justify-between">
                <span className="text-[11px] font-mono-bp uppercase tracking-[0.25em] text-white/40">
                  Rolle
                </span>
                <span className="text-[11px] font-mono-bp text-white/60">
                  {g.label}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
